// SCSS
import "../scss/index.scss";

import { TweenMax, Power2 } from "gsap/all";

// POLYFILLS
// Custom POLYFILLS
import "./toolkit/polyfills";

// Vendor POLYFILLS and initialization
import "intersection-observer";
import "objectFitPolyfill";
import "whatwg-fetch";
import cssVarsPonyfill from "css-vars-ponyfill";
cssVarsPonyfill();

// Universal MODULES:
import CookiebarBackend from "./modules/CookiebarBackend";
import MapsController from "./modules/maps/MapsController";
import ModalsController from "./modules/modals/ModalsController";
import ParallaxsController from "./modules/parallaxs/ParallaxsController";
import ScrollToController from "./modules/ScrollToController";
import SlidersController from "./modules/sliders/SlidersController";
import VLDController from "./modules/vld/VLDController";
import TabsController from "./modules/tabs/TabsController";
import TweenersController from "./modules/tweeners/TweenersController";

// Custom COMPONENTS:
import Nav from "./components/Nav";

// Various other TOOLS:
import $$ from "./toolkit/$$";

const initApp = () => {
  // initialize cookie notification:
  new CookiebarBackend();
  // initialize maps:
  new MapsController();
  // initialize modals:
  new ModalsController();
  // initialize navigation:
  new Nav();
  // initialize parallaxs:
  new ParallaxsController();
  // initialize ScrrollTo:
  new ScrollToController();
  // initialize all sliders:
  new SlidersController();
  // initialize forms:
  new TweenersController();
  // initialize tabs:
  new TabsController();
  // initialize forms:
  new VLDController();
  // // new ParallaxsController();

  const $loader = $$("[data-loader]")[0];

  TweenMax.to($loader, 0.3, {
    opacity: 0,
    ease: Power2.easeOut,
    onComplete: () => document.body.removeChild($loader),
    delay: 1.1,
  });

  if ($$("[data-header-observer]")[0]) {
    new IntersectionObserver((entries: any) => {
      const { isIntersecting } = entries[0];
      document.body.classList[isIntersecting ? "remove" : "add"](
        "header-narrow"
      );
    }).observe($$("[data-header-observer]")[0]);
  }

  // transform: matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,10,0,0,1);
};

window.onload = initApp;
